<template>
  <CustomFormBaseElement
    :value="value"
    :disabled="disabled"
    @input="handleCustomFormBaseElementInput"
  >
  </CustomFormBaseElement>
</template>

<script>
import CustomFormBaseElement from '@/components/customForms/element/CustomFormBaseElement.vue'

export default {
  name: 'CustomFormTextAreaElement',
  components: { CustomFormBaseElement },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    handleCustomFormBaseElementInput(value, key) {
      this.updateModel(value, key)
    },
    updateModel(value, key) {
      this.$emit('input', { ...this.value, [key]: value })
    },
  },
}

</script>
